export interface IWsCliente {
	IdCliente?: number;
	numDocCliente: string;
	razonSocial: string;
	direccion: string;
}

export class WsCliente {
	IdCliente?: number;
	numDocCliente: string;
	razonSocial: string;
	direccion: string;

	constructor(data?: IWsCliente) {
		if (data) {
			this.IdCliente = data.IdCliente;
			this.numDocCliente = data.numDocCliente;
			this.razonSocial = data.razonSocial;
			this.direccion = data.direccion;
		}
	}
}

export interface ISucursalesClienteDTO {
	ID_CLIENTE: string;
	ID_SUCURSAL_CLIENTE: string;
	NOM_SUCURSAL: string;
	DIRECCION: string;
	// FLG_ANULADO: boolean;
	DEPARTAMENTO: string;
	PROVINCIA: string;
	DISTRITO: string;
	ID_UBIGEO: string;
	ID_SUB_ZONA: number;
	SUB_ZONA: string;
}

export class SucursalesCliente {
	IdCliente: string;
	IdSucursalCliente: string;
	NombreSucursal: string;
	Direccion: string;
	// EstaAnulado: boolean;
	Departamento: string;
	Provincia: string;
	Distrito: string;
	IdUbigeo: string;
	IdSubZona: number;
	SubZona: string;

	constructor(data?: ISucursalesClienteDTO) {
		this.IdCliente = data.ID_CLIENTE;
		this.IdSucursalCliente = data.ID_SUCURSAL_CLIENTE;
		this.NombreSucursal = data.NOM_SUCURSAL;
		this.Direccion = data.DIRECCION;
		// this.EstaAnulado = data.FLG_ANULADO;
		this.Departamento = data.DEPARTAMENTO;
		this.Provincia = data.PROVINCIA;
		this.Distrito = data.DISTRITO;
		this.IdUbigeo = data.ID_UBIGEO;
		this.IdSubZona = data.ID_SUB_ZONA
		this.SubZona = data.SUB_ZONA
	}
}